import { Link } from "@tanstack/react-router";
import hero from "@/assets/schober/hero.webp";
import heroMobile from "@/assets/schober/hero-800.webp";
import user from "@/assets/schober/schober-slider.webp";
import userMobile from "@/assets/schober/schober-slider-600.webp";

export function Hero() {
  return (
    <section className="relative h-[450px] overflow-hidden bg-brand-navy md:h-[760px]">
      <img
        src={heroMobile}
        srcSet={`${heroMobile} 800w, ${hero} 1600w`}
        sizes="100vw"
        alt="Transporter und Möbel beim Umzug – Schober Transportservice"
        width={1600}
        height={800}
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-y-0 left-0 w-full bg-brand-navy/70 md:w-1/2" aria-hidden />

      <div className="container relative z-10 mx-auto h-full max-w-8xl px-4">
        <div className="flex h-full max-w-4xl flex-col justify-center py-10 text-white md:py-16">
          <h1 className="font-display text-3xl font-extrabold uppercase leading-tight md:text-5xl lg:text-7xl">
            UMZUG, TRANSPORT & ENTRÜMPELUNG
            <span className="mt-3 block text-lg font-bold normal-case md:text-2xl lg:text-3xl">Wien · Wiener Neustadt · Baden · Eisenstadt</span>
          </h1>
          <p className="mt-6 font-display text-2xl font-bold text-brand-orange-on-dark md:text-3xl">
            Ihr kompetenter Partner
          </p>
          <ul className="mt-2 space-y-1 font-display text-2xl font-bold uppercase md:text-3xl">
            <li>TRANSPORTSERVICE</li>
            <li>ENTRÜMPELUNGEN</li>
            <li>RÄUMUNGEN</li>
            <li>DEMONTAGEN</li>
            <li>UMZÜGE</li>
          </ul>
          <Link
            to="/kontakt"
            className="mt-8 inline-flex w-fit items-center gap-2 bg-brand-orange px-8 py-3 text-xs font-bold uppercase text-brand-orange-foreground shadow-lg transition-colors hover:bg-brand-orange/90"
          >
            Kontakt
          </Link>
        </div>
      </div>

      <img
        src={userMobile}
        srcSet={`${userMobile} 600w, ${user} 750w`}
        sizes="(max-width: 768px) 600px, 750px"
        alt="Patric Schober – Inhaber Schober Transportservice"
        width={750}
        height={515}
        loading="eager"
        decoding="async"
        className="absolute -bottom-20 -right-10 z-0 w-[1250px] max-w-none"
      />
    </section>
  );
}